import React, { SyntheticEvent } from 'react';
import DateTimeUtility from '../../../common/utility/DateTimeUtility';
import MusicAlbumDeletePopupSequence from './MusicAlbumDeletePopupSequence';
import CustomButton from '../../../common/components/CustomButton';
import { MusicAlbumArtistEntity, MusicAlbumEntity, MusicAlbumTrackEntity } from '../../types/MusicAlbumEntityTypes';
import { MusicComposerEntity, MusicEntity, MusicFeaturingArtistEntity, MusicLyricWriterEntity, MusicPerformanceRoleEntity, MusicProductionAndEngineeringRoleEntity } from '../../types/MusicEntityTypes';
import { TunecoreReleaseEntity, TunecoreReleaseTrackEntity } from '../../types/TunecoreReleaseEntityTypes';
import MusicAlbumDetailsShareView from './MusicAlbumDetailsShareView';
import MusicAlbumInfoReleaseView from './MusicAlbumInfoReleaseView';

/**
 * リリース詳細
 */
export default function MusicAlbumDetailsView({
  musicAlbum,
  cancelReasonOptions,
} : {
  musicAlbum: MusicAlbumEntity & {
    music_album_artists: MusicAlbumArtistEntity[],
    music_album_tracks: (MusicAlbumTrackEntity & {
      music: MusicEntity & {
        music_featuring_artists: MusicFeaturingArtistEntity[],
        music_lyric_writers: MusicLyricWriterEntity[],
        music_composers: MusicComposerEntity[],
        music_production_and_engineering_roles: MusicProductionAndEngineeringRoleEntity[],
        music_performance_roles: MusicPerformanceRoleEntity[],
        tunecore_release_track: TunecoreReleaseTrackEntity,
      },
    })[],
    tunecore_release: TunecoreReleaseEntity,
  }
  cancelReasonOptions: {
    text: string,
    value: string,
  }[],
}) {
  const [popup, setPopup] = React.useState<string|null>(null);

  const handleDeleteDone = () => {
    if (musicAlbum.release_status === 0 || musicAlbum.release_status === 4) {
      document.location.href = '/music_albums/';
    } else {
      document.location.reload();
    }
  };

  return (
    <>
      {musicAlbum.release_status === 0 && (
        <>
          { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
          <label className="edit">編集中</label>
        </>
      )}
      {musicAlbum.release_status === 7 && (
        <>
          { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
          <label className="process">手続き中</label>
        </>
      )}
      {musicAlbum.release_status === 2 && (
        <>
          { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
          <label className="delivery">配信中</label>
        </>
      )}
      {musicAlbum.release_status === 3 && (
        <>
          { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
          <label className="delivery">配信停止の手続き中</label>
        </>
      )}
      {musicAlbum.release_status === 4 && (
        <>
          { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
          <label className="stop">配信停止</label>
        </>
      )}
      {musicAlbum.release_status === 6 && (
        <>
          { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
          <label className="stop">配信不可</label>
          <p style={{
            color: 'red', background: '#ff000014', borderRadius: '5px', padding: '20px', marginBottom: '30px', fontSize: '14px',
          }}
          >
            このリリースをFrekulから配信することはできません。
            <br />
            審査はFrekul内で完結せず、基準も随時変化するため、配信不可となった理由を個別にお伝えすることができません。
            <br />
            大変申し訳ございませんが、ご理解いただけますようお願いいたします。
          </p>

        </>
      )}
      {musicAlbum.release_status === 7 && (
        <>
          { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
          <label className="process">手続き中</label>
        </>
      )}
      {musicAlbum.release_status === 8 && (
        <>
          { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
          <label className="process">手続き中</label>
        </>
      )}
      {musicAlbum.release_status === 9 && (
        <>
          { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
          <label className="process">手続き中</label>
        </>
      )}
      <form className="music_list">
        <MusicAlbumDetailsShareView musicAlbum={musicAlbum} />
        <MusicAlbumInfoReleaseView musicAlbum={musicAlbum} />
        <ul>
          <li className="bt">
            <CustomButton type="cancel" onClick={() => { document.location.href = '/music_albums/'; }}>戻る</CustomButton>
          </li>
        </ul>
        <CustomButton type="secondary-cancel" onClick={() => { setPopup('delete'); }}>リリースを削除</CustomButton>
      </form>
      {popup === 'delete' && (
        <MusicAlbumDeletePopupSequence
          musicAlbum={musicAlbum}
          cancelReasonOptions={cancelReasonOptions}
          onCancel={() => { setPopup(null); }}
          //onDone={() => { handleDeleteDone(); }}
        />
      )}
    </>
  );
}
